import { api } from "./apiConfig";

export const getAvailabilities = async () => {
  const { data } = await api.get("/availability");
  return data;
};

export const saveAvailability = async (data) => {
  await api.post("/availability", data);
};

export const patchAvailability = async ({ id, formData }) => {
  if (formData instanceof FormData) {
    formData = Object.fromEntries(formData.entries());
  }
  await api.patch(`/availability/${id}`, { ...formData });
};

export const updateAvailability = async ({ id, data }) => {
  await api.put(`/availability/${id}`, data);
};

export const deleteAvailability = async (id) => {
  await api.delete(`/availability/${id}`);
};
